import { Component, input } from '@angular/core'

/**
 * A screen shown instead of a page - `/load-failed`, the not-found page - that says one thing: a heading, a sentence,
 * and the action projected under them. The heading is an `h2`, like the public page's own "not found": `base.css`
 * sizes every `h1` at `--size-font-5xl` with `!important`, which no component can override (docs/design-system.md,
 * _Open work_).
 */
@Component({
  selector: 'seiri-page-message',
  template: `
    <main class="page-message">
      <h2>{{ heading() }}</h2>
      <p>{{ text() }}</p>
      <ng-content />
    </main>
  `,
  styles: `
    .page-message {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--space-16);
      padding: var(--space-80) var(--space-16);
      text-align: center;
    }

    h2 {
      margin: 0;
      font: var(--mat-sys-headline-small);
      color: var(--theme-fg-heading);
    }

    p {
      margin: 0;
      font: var(--mat-sys-body-large);
      color: var(--theme-fg-muted);
    }
  `,
})
export class PageMessageComponent {
  readonly heading = input.required<string>()
  readonly text = input.required<string>()
}
